import { Box, Container, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import favorite from '../../assets/images/favorite.png';
import { CheckCircleOutline } from '@mui/icons-material';
import { useInView } from '../../hooks/useInView';

const PRIMARY = '#8c7c0c';

const FEATURES = [
    'Browse and filter verified property listings',
    'Apply for rentals directly through the app',
    'Make rent and utility payments in one place',
    'Access full payment history and download receipts',
    'Receive automated rent reminders',
    'Rate and review properties and landlords',
    'Read tenant reviews before signing a lease',
    'Deposit protected under Silver & Gold plans',
];

const HouseSeeker: FC = () => {
    const { ref, visible } = useInView();

    return (
        <Box component="section" id="house_seeking" ref={ref} sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
                    {/* Image — hidden on mobile */}
                    <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
                        <Box className={`sg-reveal-left ${visible ? 'sg-visible' : ''}`}>
                            <img
                                src={favorite}
                                alt="Find your perfect home"
                                loading="lazy"
                                style={{ height: 580, width: 'auto', objectFit: 'contain', filter: 'drop-shadow(0 16px 40px rgba(0,0,0,.1))' }}
                            />
                        </Box>
                    </Grid>

                    {/* Copy */}
                    <Grid item xs={12} md={7}>
                        <Box className={`sg-reveal-right ${visible ? 'sg-visible' : ''}`}>
                            <Typography sx={{ display: 'inline-block', bgcolor: `${PRIMARY}12`, color: PRIMARY, px: 2, py: 0.5, borderRadius: 20, fontSize: 13, fontWeight: 600, mb: 2 }}>
                                For House Seekers
                            </Typography>
                            <Typography component="h2" sx={{ fontSize: { xs: 30, md: 42 }, fontWeight: 800, color: '#111827', lineHeight: 1.2, mb: 2 }}>
                                Your Next Home Is Just a Click Away
                            </Typography>
                            <Typography sx={{ fontSize: 16, color: '#6b7280', lineHeight: 1.7, mb: 4 }}>
                                Find verified rentals, pay securely, and build a strong payment record — all from the Sheltergram app.
                            </Typography>

                            <Grid container spacing={1.5}>
                                {FEATURES.map((f, i) => (
                                    <Grid item xs={12} sm={6} key={f}>
                                        <Box
                                            className={`sg-reveal ${visible ? 'sg-visible' : ''}`}
                                            style={{ transitionDelay: `${i * 0.05}s` }}
                                            sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}
                                        >
                                            <CheckCircleOutline sx={{ color: PRIMARY, fontSize: 18, mt: 0.3, flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: 14.5, color: '#374151' }}>{f}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>

                            <Box sx={{ mt: 4 }}>
                                <a href="/auth?signup=true" className="sg-btn-primary">
                                    Find a Home
                                </a>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default HouseSeeker;
